import { render, staticRenderFns } from "./Index1.vue?vue&type=template&id=801991b4&scoped=true&"
import script from "./Index1.vue?vue&type=script&lang=js&"
export * from "./Index1.vue?vue&type=script&lang=js&"
import style0 from "./Index1.vue?vue&type=style&index=0&id=801991b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801991b4",
  null
  
)

export default component.exports